import { ChangeDetectionStrategy, Component, output } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'ml-dep-devices-delete',
  templateUrl: './dep-devices-delete.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FaIconComponent],
})
export class DepDevicesDeleteComponent {
  readonly deleted = output();

  public onDelete() {
    this.deleted.emit();
  }
}
